@for (row of rows; track row; let rowIndex = $index) {
  <!-- $any() is needed because row[rowId] is typed as T[keyof T], but the map key is always a string at runtime -->
  @let mainGuestHasAgeIssue = mainGuestAgeIssueIdMap()[$any(row[rowId])];

  <div class="spa-list-guest-container" data-testid="guest_including_companions">
    <div class="spa-list-row" data-testid="main_guest">
      <div
        class="spa-list-row"
        (click)="onClickRow(row)"
        [ngClass]="{
          'spa-list-selected-row': row[rowId] === selectedRow,
          'spa-list-hint': rowContainsHint(row[rowId]),
          'spa-list-age-issue': mainGuestHasAgeIssue,
          'spa-list-interactive': interactive,
        }"
        id="list-row-{{ rowIndex }}"
        data-testid="selected_person"
      >
        <spa-button
          (clickedButton)="removeSelectedEmployee(rowIndex)"
          id="list-row-delete-btn-{{ rowIndex }}"
          shape="link"
          asset="close"
          data-testid="remove_selected_person_button"
        ></spa-button>

        @if (columns?.left?.length) {
          @for (column of columns.left; track column; let j = $index) {
            <div class="spa-list-element-container" [ngClass]="[column.size ?? '']" [attr.data-testid]="column.key">
              @if (getTemplate(column.key); as tmp) {
                <ng-container *ngTemplateOutlet="tmp.template; context: { row }"></ng-container>
              } @else {
                <dx-text-input
                  label="{{ (translationKey(column) | transloco) || null }}"
                  value="{{ cellValue(row, column) }}"
                  readonly="true"
                  [ngClass]="[column.size ?? '']"
                  id="{{ column.key }}-{{ rowIndex }}"
                  [attr.data-testid]="column.key"
                ></dx-text-input>
              }
            </div>
          }
        }
      </div>

      @if (columns?.right?.length) {
        @for (column of columns.right; track column) {
          <div class="spa-list-element-container" id="{{ column.key }}-{{ rowIndex }}" [ngClass]="[column.size ?? '']">
            @if (getTemplate(column.key); as tmp) {
              <ng-container *ngTemplateOutlet="tmp.template; context: { row }"></ng-container>
              <div class="spa-list-newprice-tag" id="newprice-{{ rowIndex }}"></div>
            } @else {
              <dx-text-input
                label="{{ (translationKey(column) | transloco) || null }}"
                value="{{ cellValue(row, column) }}"
                readonly="true"
                [ngClass]="[column.size ?? '']"
                id="{{ column.key }}-{{ rowIndex }}"
              ></dx-text-input>
            }
          </div>
        }
      }
    </div>

    <!-- Age restriction -->
    @if (mainGuestHasAgeIssue) {
      <dx-error-message>{{
        "text.booking.guest-has-age-issue"
          | transloco
            : {
                age: (row["birthdate"] | calculateAge),
                ageRestriction:
                  ("dto.products.age-restriction." + bookingCompanionService.s_selectedProduct()?.ageRestriction
                  | transloco),
              }
      }}</dx-error-message>
    }

    <!-- Overlapping bookings -->
    <div
      class="spa-list-bottom-space-and-hint-text"
      [title]="rowContainsHint(row[rowId]) ? hintText : ''"
      data-testid="overlapping_booking_hint"
    >
      {{ rowContainsHint(row[rowId]) ? hintText : "" }}
    </div>

    @if (columns?.bottom?.length) {
      @for (column of columns.bottom; track column) {
        @if (getTemplate(column.key); as tmp) {
          <ng-container *ngTemplateOutlet="tmp.template; context: { row }"></ng-container>
        }
      }
    }

    @if (numberOfCompanions() > 0 && !isDifferentPayer) {
      <dx-accordion-group>
        <dx-accordion
          class="spa-list-companions"
          data-testid="companions_section"
          [label]="`Companions (${(bookingCompanionService.s_companionMap() | filledCompanions: rowIndex)} / ${numberOfCompanions()})`"
        >
          @for (control of form.controls.companions.controls; track control; let columnIndex = $index) {
            @let companionHasAgeIssue = companionAgeIssueIdMap()[rowIndex + "-" + columnIndex];

            <div class="spa-list-companion" data-testid="companion">
              <div class="spa-list-companions-title">Companion {{ columnIndex + 1 }}</div>
              <div
                class="spa-list-row"
                data-testid="selected_companion"
                id="list-row-{{ rowIndex }}"
                [ngClass]="{ 'spa-list-age-issue': companionHasAgeIssue }"
              >
                @if (bookingCompanionService.s_companionMap()[rowIndex + "-" + columnIndex]) {
                  <spa-button
                    (clickedButton)="removeSelectedCompanion(rowIndex, columnIndex)"
                    class="spa-button-close smaller"
                    shape="link"
                    asset="close"
                    data-testid="remove_companion_button"
                  ></spa-button>
                  <div class="spa-list-element-container medium" data-testid="companion_name">
                    <dx-text-input
                      readonly="true"
                      value="{{ bookingCompanionService.s_companionMap()[rowIndex + '-' + columnIndex].lastName }},
                  {{ bookingCompanionService.s_companionMap()[rowIndex + '-' + columnIndex].firstName }}"
                    ></dx-text-input>
                  </div>
                  <div class="spa-list-element-container small" data-testid="companion_cabin_number">
                    <dx-text-input
                      readonly="true"
                      value="{{ bookingCompanionService.s_companionMap()[rowIndex + '-' + columnIndex].cabinNumber }}"
                    ></dx-text-input>
                  </div>
                  <div class="spa-list-element-container xsmall-ar" data-testid="companion_age_restriction">
                    <dx-text-input
                      readonly="true"
                      [value]="
                        'dto.products.age-restriction.' + simpleProduct()?.companions[columnIndex]?.ageRestriction
                          | transloco
                      "
                    ></dx-text-input>
                  </div>
                  <div class="spa-list-element-container xsmall-pr" data-testid="companion_price">
                    <dx-text>{{ simpleProduct()?.companions[columnIndex]?.price | formatPricePipe }}</dx-text>
                  </div>
                }
                @if (!bookingCompanionService.s_companionMap()[rowIndex + "-" + columnIndex]) {
                  <div
                    class="spa-autocomplete-search-container"
                    [ngClass]="{
                      'spa-guest-selection-margin-top': bookingCompanionService.s_companionMap(),
                    }"
                  >
                    <spa-autocomplete-search
                      checkboxSelectionType="single"
                      class="spa-search"
                      data-testid="guest_search"
                      [columns]="autocompleteColumns"
                      [isSearching]="isSearching()[rowIndex + '-' + columnIndex]"
                      [rows]="guestSearchResultsMap()[rowIndex + '-' + columnIndex]"
                      (fetchData)="loadGuests($event, rowIndex, columnIndex)"
                      (selectRow)="onSelectCompanions($event, rowIndex, columnIndex)"
                    >
                      <spa-autocomplete-template columnKey="imageUri">
                        <ng-template let-guest="row">
                          <img
                            [src]="guest.data.imageUri | imageUrl"
                            alt="{{ guest.data.lastName }}, {{ guest.data.firstName }}"
                            class="spa-guest-selection-autocomplete-search-img"
                          />
                        </ng-template>
                      </spa-autocomplete-template>
                    </spa-autocomplete-search>
                  </div>
                }
              </div>
            </div>

            <!-- Age restriction -->
            @if (companionHasAgeIssue) {
              <dx-error-message>{{
                "text.booking.guest-has-age-issue"
                  | transloco
                    : {
                        age:
                          (bookingCompanionService.s_companionMap()[rowIndex + "-" + columnIndex]?.birthdate
                          | calculateAge),
                        ageRestriction:
                          ("dto.products.age-restriction." + simpleProduct()?.companions[columnIndex]?.ageRestriction
                          | transloco),
                      }
              }}</dx-error-message>
            }
          }
        </dx-accordion>
      </dx-accordion-group>
    }

    <div class="footer-container">
      <dx-spacer />
      @if (!isDifferentPayer && numberOfCompanions() > 0) {
        <div class="spa-sub-total-container">
          <dx-text type="its">{{ "label.subtotal" | transloco }}</dx-text>
          <dx-text
            type="ps-bold"
            [ngClass]="{
              discounted:
                bookingCompanionService.s_subTotalPriceMap()[rowIndex] !==
                bookingCompanionService.s_subTotalNetPriceMap()[rowIndex],
            }"
            data-testid="guest_subtotal_price_original"
            >{{ bookingCompanionService.s_subTotalPriceMap()[rowIndex] | formatPricePipe }}</dx-text
          >
          @if (
            bookingCompanionService.s_subTotalPriceMap()[rowIndex] !==
            bookingCompanionService.s_subTotalNetPriceMap()[rowIndex]
          ) {
            <dx-text type="ps-bold" class="netto-price" data-testid="guest_subtotal_price_discounted">
              {{ bookingCompanionService.s_subTotalNetPriceMap()[rowIndex] | formatPricePipe }}</dx-text
            >
          }
        </div>
      }
    </div>
  </div>
}
